import { verifyResaleCode } from "@/services/resale";

export const useResaleCode = () => {
  const validateResaleCode = async (code: string) => {
    try {
      await verifyResaleCode(code);
      return true;
    } catch {
      return false;
    }
  };

  const getStoreInfo = async (code: string) => {
    return verifyResaleCode(code);
  };

  return { validateResaleCode, getStoreInfo };
};
